const COLLECTIONS = [
  "sei1gu3lzz75ttmnwjua7meachry4x3avfdhjv0t9jlz8xvnxweh7ersc7l78r",
  "sei1v90ly54qeu7497lzk2mnmp2h29sgtep8hs5ryvfqf8dwq5gc0t9srp6aey",
  "sei1pkteljh83a83gmazcvam474f7dwt9wzcyqcf5puxvqqs6jcx8nnq2y74lu",
  "sei1vjgrptlrm0alx330lv6260kzewv7p8elpputvedd45sxrtel2v5qzkrcd7",
];
const MARKETPLACE =
  "sei146evv8symmx4gwhheu8j3reh8l6j8z46v9mp6uutyz8s5l844jls6lju6k";
// sei1cuzy5j7y2hrnr4ek42gfzs5hte7lvk8q50xtzuykmceza04mgl7q7phzaz
//sei1he0dhh5sacyu5hxdm7n9evzvwlnzhzpazpk7tjy5dscf4rys5d0qevyfs5
//sei1tn2nr6trscuxw8csd7ujmy9y66v85fsawnrr4fj7g8d905fx9uuq47yu8l
const CREATOR_ADDRESS = "H8eT4HyS1Tq4DM5S3qj2Y3QtAHaZ9ejqWfjUkzoETCLe";
const PALLET_MARKETPLACE =
  "sei152u2u0lqc27428cuf8dx48k8saua74m6nql5kgvsu4rfeqm547rsnhy4y9";
const SOLANA_RPC = "https://solana-devnet.g.alchemy.com/v2/kx1E5YX95Ux3TnsZgFzfAIjLu83grbkc";
const SOLANA_DECIMAL = 1000000000;
const LISTING_PAGE_COUNT = 22;

module.exports = {
  COLLECTIONS,
  MARKETPLACE,
  PALLET_MARKETPLACE,
  SOLANA_DECIMAL,
  LISTING_PAGE_COUNT,
  CREATOR_ADDRESS,
  SOLANA_RPC,
};
